import {useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { HashLink } from 'react-router-hash-link';
import { FaWhatsapp } from "react-icons/fa";
import ResetCursor from './utils/ResetCursor';

const Hire = () => {

    useEffect(() => {
        AOS.init({
          duration: 1500,
            once: true,
        });
    },[]);

    return (
    <section className="section-sm bg-primary" id="hire">
        <div className="container text-center text-sm-left">
            <div className="row align-items-center">
                <div className="col-sm offset-md-1 mb-4 mb-md-0"  data-aos="fade-right">
                    <h6 className="title text-light">Want to work with me?</h6>
                    <p className="m-0 text-light">Always feel Free to Contact & Hire me</p>
                </div>
                <div className="hire-me-btn col-sm offset-sm-2 offset-md-3"  data-aos="fade-left">
                    <HashLink
                        to='/#contact'
                        onClick={ResetCursor()} 
                        className="btn btn-lg my-font btn-light rounded"
                    >
                        Hire Me
                    </HashLink>
                    <a
                        href="https://wa.me/918982896759?text=Hi%20Tehzeeb,%20I%20visited%20your%20portfolio%20and%20would%20like%20to%20discuss%20a%20project."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="what-btn btn btn-lg my-font mx-1 btn-outline-light rounded"
                    >
                        <FaWhatsapp className="mr-1" size={20}/>
                        WhatsApp
                    </a>
                </div>
            </div> 
        </div> 
    </section> 
    );
}

export default Hire ;